



























import {Component, Prop, Vue} from 'vue-property-decorator';
import {DataItem} from 'vis-timeline/esnext';

@Component
export default class TimelineDialogTemplate extends Vue {

    @Prop() item!: DataItem | null;
    @Prop({
        required: false,
        default: 'unset'
    }) width!: number | string;

    showDialog: boolean = true;

    close() {
        this.showDialog = false;
        this.$emit('close');
    }
}
